var o;(function(o){o["both"]="both";o["x"]="x";o["y"]="y"})(o||(o={}));export{o as PanAxes};
